package com.essntl.features.country.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.country.data")
class CountryModule